import { Component } from "react";
import { ListGroup } from "react-bootstrap";
import { FaHome, FaCalendarAlt } from "react-icons/fa";
import { hasPerm, getCurrentUser, tiposAcesso, decryptData, encryptData } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import api from "../../services/api";
import logomarca from '../../assets/images/logo-hns.png';
import GlobalContext from '../../contexts/GlobalContext';

//Imports tipo usuario
import Menu from "./Menu";
import MenuGestor from "./MenuGestor";
import MenuOperador from "./MenuOperador";
import MenuPrestador from "./MenuPrestador";

import MenuInsideSales from "./MenuInsideSales";

class SideV2 extends Component {
    static contextType = GlobalContext;
    constructor(props) {
        super(props);
        
        this.expandUsuarioMenu = this.expandUsuarioMenu.bind(this);
        this.handleConfigLoaded = this.handleConfigLoaded.bind(this);

        this.state = {
            usuarioExpanded: false,
            classesUsuario: 'submenu collapse',
            programa_logomarca: '',
            loaded_logomarca: false,
            perfil_gestor_industria: false,
            faturamentosPendentes: 0,
            noDashboard: null,
            loading_pendentes: false,
            ocultar_receptivos: false,
            ocultar_atendimentos: false,
            ocultar_prestadores: false,
            gestao_aplicacoes: false,
            menus_adicionais: [],
            configuracoes_carregadas: false,
            tipo_gestor: null,
        }
    }

    async componentDidMount() {
        const dados_usuario = getCurrentUser();   
        const programaId = dados_usuario['ambiente_programa_id'];

        window.addEventListener("programa_configuracoes_carregadas", this.handleConfigLoaded)

        if (programaId) {
            await this.carregaProgramaAmbiente(programaId);
        } else {
            // Prestador (medico) ainda escolhendo o ambiente: usa a logo do 1o programa vinculado
            // (ex.: Chiesi -> Cuidados Raros) no lugar da logo do HNS. prestador_id vem de tiposAcesso()
            // (getCurrentUser nao tem prestador_id antes de escolher o programa).
            const tipos_acesso = tiposAcesso();
            const chavePrestador = Object.keys(tipos_acesso).find(k => tipos_acesso[k] && tipos_acesso[k]['prestador_id']);
            const prestadorId = chavePrestador ? tipos_acesso[chavePrestador]['prestador_id'] : null;
            if (prestadorId) {
                // NAO libera loaded_logomarca aqui: aguarda a logo do programa pra nao piscar a logo
                // do HNS. carregaLogoPreSelecao libera ao terminar (com a logo do programa ou, se nao
                // houver, caindo no fallback HNS).
                this.setState({ noDashboard: true, configuracoes_carregadas: true });
                this.carregaLogoPreSelecao(prestadorId);
            } else {
                this.setState({ noDashboard: true, loaded_logomarca: true, configuracoes_carregadas: true });
            }
        }

        if(dados_usuario['tipo_usuario'] == "operador" && !hasPerm('view_programas_graficos')){
            this.setState({noDashboard: true});
        }

        const pathname = this.props.router.location.pathname;

        if(pathname.indexOf('/usuarios') !== -1 || pathname.indexOf('/grupos') !== -1 || pathname.indexOf('/logs') !== -1){
            this.setState({
                classesUsuario: 'submenu collapse show',
            })
        }      

        this.verificaPerfilGestorIndustria();
    }

    componentWillUnmount() {
        window.removeEventListener("programa_configuracoes_carregadas", this.handleConfigLoaded);
    }

    handleConfigLoaded() {
        const dados_usuario = getCurrentUser();
        const programaId = dados_usuario['ambiente_programa_id'];
        this.verificaDashboardDisponivel(programaId, dados_usuario);
    }

    verificaDashboardDisponivel = (programaId, dados_usuario) => {
        let hasGraphs = false;
        try {
            const configRaw = localStorage.getItem(`programa_configuracoes_${programaId}`);
            if (configRaw) {
                const config = JSON.parse(configRaw);
                if (Array.isArray(config.graficos_dashboard) && config.graficos_dashboard.length > 0) {
                    hasGraphs = true;
                }
            }

        } catch (err) {
            console.error("[!] Error checking graphs in localStorage:", err);
            hasGraphs = false;
        }

        let hasPermission = true;
        const perms = dados_usuario['permissions'] || [];
        
        if (dados_usuario['tipo_usuario'] === "operador") {
            if (!perms.some((p) => p.includes("view_programas_graficos"))) {
                hasPermission = false;
            }
        } 
        
        const finalNoDashboard = !hasGraphs || !hasPermission; 

        this.setState({
            noDashboard: finalNoDashboard,
            configuracoes_carregadas: true
        });
    }

    verificaPerfilGestorIndustria = () => {
        const tipos_acesso = tiposAcesso();

        if ('gestor' in tipos_acesso) {
            const tipoGestor = tipos_acesso.gestor.tipo_gestor || null;
            
            this.setState({ 
                perfil_gestor_industria: tipoGestor === 'industria',
                tipo_gestor: tipoGestor  // 'industria', 'interno', etc.
            });            
        }
    }

    carregaFaturamentosPendentes = () => {
        if(this.state.loading_pendentes) {
            return;
        }
        let dados_usuario = getCurrentUser();    
        this.setState({ loading_pendentes: true });
        api.get('/faturamento/pendentes/?tipo_usuario=' + dados_usuario['tipo_usuario'])
            .then(response => {
                if (response.status === 200 && response.data.count > 0) {
                    this.setState({ faturamentosPendentes: response.data.count, loading_pendentes: false });
                }
            })
            .catch(error => {
                console.error('Erro ao carregar faturamentos pendentes:', error);
            });
    };

    // Logo exibida enquanto o prestador (medico) ainda nao escolheu o programa: usa a imagem do
    // primeiro programa vinculado a ele (ex.: Chiesi -> Cuidados Raros), evitando cair na logo do HNS.
    carregaLogoPreSelecao = async (prestador_id) => {
        try {
            const resp = await api.get(`/programas/prestadores/?prestador_id=${prestador_id}`);
            const lista = resp?.data?.results || [];
            const primeiroProgramaId = lista[0]?.programa_id;
            if (primeiroProgramaId) {
                const { data } = await api.get(`/programas/${primeiroProgramaId}/`);
                if (data?.imagem) {
                    this.setState({ programa_logomarca: data.imagem });
                }
            }
        } catch (e) {
            // qualquer falha: mantem o fallback (logo HNS)
        } finally {
            // So agora libera a exibicao: se achou a logo do programa, mostra ela; senao, cai no
            // fallback HNS. Evita piscar o HNS enquanto a logo do programa carrega.
            this.setState({ loaded_logomarca: true });
        }
    };

    carregaProgramaAmbiente = (programa_id) => {
    return new Promise((resolve, reject) => {
        const cachedLogomarca = localStorage.getItem(`programa_logomarca_${programa_id}`);
        const cachedTipoSlug = localStorage.getItem(`programa_tipo_slug_${programa_id}`);
        const cachedNomePrograma = localStorage.getItem(`programa_nome_${programa_id}`);
        const cachedLogomarcaTimestamp = localStorage.getItem(`programa_logomarca_timestamp_${programa_id}`);
        const cachedOcultarReceptivos = localStorage.getItem(`programa_ocultar_receptivos_${programa_id}`);
        const cachedOcultarAtendimentos = localStorage.getItem(`programa_ocultar_atendimentos_${programa_id}`);
        const cachedOcultarPrestadores = localStorage.getItem(`programa_ocultar_prestadores_${programa_id}`);
        const cachedMenusAdicionais = localStorage.getItem(`programa_menus_adicionais_${programa_id}`);
        const cachedGestaoAplicacoes = localStorage.getItem(`programa_gestao_aplicacoes_${programa_id}`);
        const cachedHabilitarTelaCodVeeva = localStorage.getItem(`programa_habilitar_tela_cod_veeva_${programa_id}`);
        const cachedConfiguracoes = localStorage.getItem(`programa_configuracoes_${programa_id}`);
        const cachedPogramaTipo = localStorage.getItem(`programa_tipo_${programa_id}`);
        
        const currentTime = new Date().getTime();
        const expirationTime = 1 * 60 * 60 * 1000; // 1 hora

        const cacheValido = (
            cachedLogomarca &&
            cachedLogomarca !== "null" &&
            cachedLogomarcaTimestamp &&
            cachedNomePrograma &&
            cachedPogramaTipo &&
            cachedGestaoAplicacoes &&
            cachedConfiguracoes &&
            (currentTime - parseInt(cachedLogomarcaTimestamp) < expirationTime)
        );

        if (cacheValido) {
            this.setState({ 
                programa_logomarca: cachedLogomarca, 
                tipo_programa_slug: cachedTipoSlug,
                loaded_logomarca: true, 
                ocultar_receptivos: cachedOcultarReceptivos === 'sim', 
                ocultar_atendimentos: cachedOcultarAtendimentos === 'sim', 
                ocultar_prestadores: cachedOcultarPrestadores === 'sim',
                menus_adicionais: cachedMenusAdicionais ? JSON.parse(cachedMenusAdicionais) : [],
                gestao_aplicacoes: cachedGestaoAplicacoes === 'sim',
                habilitar_tela_cod_veeva: cachedHabilitarTelaCodVeeva === 'sim',
            });

            this.verificaDashboardDisponivel(programa_id, getCurrentUser());
            resolve();
            return;
        }

        // Cache inválido: buscar da API
        if (programa_id) {
            api.get(`/programas/${programa_id}/`)
                .then(response => {
                    const ocultar_receptivos = response.data.ocultar_menu_receptivos === true ? 'sim' : 'nao';
                    const ocultar_atendimentos = response.data.ocultar_menu_atendimentos === true ? 'sim' : 'nao';
                    const ocultar_prestadores = response.data.ocultar_menu_prestadores === true ? 'sim' : 'nao';
                    const gestao_aplicacoes = response.data.habilitar_gestao_aplicacoes === true ? 'sim' : 'nao';
                    const habilitar_tela_cod_veeva = response.data.habilitar_tela_cod_veeva === true ? 'sim' : 'nao';
                    const tipoSlug = response.data.dados_tipo ? response.data.dados_tipo.slug : '';
                    const sidebar_atendimentos_pacientes = response.data.sidebar_atendimentos_pacientes === true ? 'sim' : 'nao';

                    const menusAdicionais = response.data.dados_status
                        .filter(status => status.menu_adicional_atendimento)
                        .map(status => ({
                            id: status.id,
                            menu_adicional_atendimento: status.menu_adicional_atendimento,
                        }));
                    
                    this.setState({ 
                        programa_logomarca: response.data.imagem, 
                        loaded_logomarca: true, 
                        tipo_programa_slug: tipoSlug,
                        ocultar_receptivos: ocultar_receptivos === 'sim' ? true : false,
                        ocultar_atendimentos: ocultar_atendimentos === 'sim' ? true : false,
                        ocultar_prestadores: ocultar_prestadores === 'sim' ? true : false,
                        gestao_aplicacoes: gestao_aplicacoes === 'sim' ? true : false,
                        menus_adicionais: menusAdicionais,
                        habilitar_tela_cod_veeva: habilitar_tela_cod_veeva === 'sim',
                    });
                    localStorage.setItem(`programa_logomarca_${programa_id}`, response.data.imagem);
                    localStorage.setItem(`programa_nome_${programa_id}`, response.data.nome);
                    localStorage.setItem(`programa_logomarca_timestamp_${programa_id}`, currentTime);
                    localStorage.setItem(`programa_tipo_slug_${programa_id}`, tipoSlug);
                    localStorage.setItem(`programa_ocultar_receptivos_${programa_id}`, ocultar_receptivos);
                    localStorage.setItem(`programa_ocultar_atendimentos_${programa_id}`, ocultar_atendimentos);
                    localStorage.setItem(`programa_ocultar_prestadores_${programa_id}`, ocultar_prestadores);
                    localStorage.setItem(`programa_gestao_aplicacoes_${programa_id}`, gestao_aplicacoes);
                    localStorage.setItem(`programa_habilitar_tela_cod_veeva_${programa_id}`, habilitar_tela_cod_veeva);
                    localStorage.setItem(`programa_menus_adicionais_${programa_id}`, JSON.stringify(menusAdicionais));
                    localStorage.setItem(`programa_tipo_${programa_id}`, response.data.dados_tipo?.slug || '');

                    localStorage.setItem(`programa_configuracoes_${programa_id}`, JSON.stringify(response.data.configuracoes || {}));
                    localStorage.setItem(`programa_configuracoes_timestamp_${programa_id}`, new Date().getTime());

                    // Aguarda 100ms para garantir persistência e chama a verificação
                    setTimeout(() => {
                        this.verificaDashboardDisponivel(programa_id, getCurrentUser());
                    }, 100);

                    // Atualiza UUID e finaliza a Promise
                    let dados_prog = decryptData('prog');
                    if (dados_prog) {
                        dados_prog['ambiente_programa_uuid'] = response.data.uuid;
                        encryptData('prog', dados_prog);
                    }

                    resolve();
                })
                .catch(error => {
                    console.error('Erro ao carregar programa:', error);
                    this.setState({
                        loaded_logomarca: true,
                        programa_logomarca: null,
                        configuracoes_carregadas: true, // garante que não trave
                    });
                    reject(error);
                });
                } else {
                    resolve();
                }
            });
    };

    expandUsuarioMenu = (e) => {   
        const classe = (this.state.usuarioExpanded) ? 'submenu collapse' : 'submenu collapse show';

        this.setState({
            classesUsuario: classe,
            usuarioExpanded: !this.state.usuarioExpanded,
        })
    };

   render() {
    const dados_usuario = getCurrentUser();
    const pathname = this.props.router.location.pathname;
    const search = this.props.router?.location?.search || "";
    const currentSlug = this.state.tipo_programa_slug || localStorage.getItem(`programa_tipo_slug_${dados_usuario["ambiente_programa_id"]}`);

        const isGestor = dados_usuario.tipo_usuario === 'gestor';
        const isGestorInterno = isGestor && !this.state.perfil_gestor_industria; 

        const isSuperUser = dados_usuario.tipo_usuario === "" || dados_usuario.is_superuser;
        const isOperador = dados_usuario.tipo_usuario === 'operador';

        const showSuporteMenu = isGestorInterno || isSuperUser || isOperador;

        if (!this.state.configuracoes_carregadas) {
            return (
                <div className="sidebar-heading mb-3">
                    {this.state.loaded_logomarca === true && (
                        <>
                            {this.state.programa_logomarca ? (
                                <img className="img-sidebar" src={this.state.programa_logomarca} alt="Aditus" />
                            ) : (
                                <img className="img-sidebar" src={logomarca} alt="Aditus" />
                            )}
                        </>
                    )}
                </div>
            );
        }

        const commonMenuProps = {
            pathname,
            search,
            faturamentosPendentes: this.state.faturamentosPendentes,
            perfil_gestor_industria: this.state.perfil_gestor_industria,
            ocultar_receptivos: this.state.ocultar_receptivos,
            ocultar_atendimentos: this.state.ocultar_atendimentos,
            ocultar_prestadores: this.state.ocultar_prestadores,
            gestao_aplicacoes: this.state.gestao_aplicacoes,
            menus_adicionais: this.state.menus_adicionais,
            habilitar_tela_cod_veeva: this.state.habilitar_tela_cod_veeva,
            noDashboard: this.state.noDashboard,
            ambiente_programa_id: dados_usuario["ambiente_programa_id"],
            showSuporteMenu: showSuporteMenu,
            tipo_gestor: this.state.tipo_gestor,
        };

        return (
            <>
                <div className="sidebar-heading mb-3">
                    {this.state.loaded_logomarca === true && (
                        <>
                            {this.state.programa_logomarca ? (
                                <img className="img-sidebar" src={this.state.programa_logomarca} alt="Aditus" />
                            ) : (
                                <img className="img-sidebar" src={logomarca} alt="Aditus" />
                            )}
                        </>
                    )}
                </div>               

        {dados_usuario["acesso_liberado"] === true ? (
            <>
            {dados_usuario["tipo_usuario"] === "prestador" && (
                <MenuPrestador {...commonMenuProps} />
            )}

            {dados_usuario["tipo_usuario"] === "beneficiario" && (
                <>
                    <div className="list-divider"> <p>Atendimentos</p> </div>

                    {hasPerm("view_agendamentos") && (
                        <ListGroup variant="flush">
                            <ListGroup.Item action href="/agendamentos" className="itemMenu" active={pathname.indexOf("/agendamentos") !== -1} >
                                <FaCalendarAlt /> Agendamentos
                            </ListGroup.Item>
                        </ListGroup>
                    )}
                </>
            )}

            {dados_usuario["tipo_usuario"] === "gestor" && <MenuGestor {...commonMenuProps} />}

            {dados_usuario["tipo_usuario"] === "operador" && (
                            currentSlug === 'inside-sales' 
                            ? <MenuInsideSales {...commonMenuProps} /> 
                            : <MenuOperador {...commonMenuProps} />
                        )}

            {/* Admin/Outro tipo: mostra tudo */}
            {["prestador", "beneficiario", "gestor", "operador"].indexOf(dados_usuario["tipo_usuario"]) === -1 && (
                <Menu {...commonMenuProps} />
            )}
            </>
        ) : (
            <ListGroup variant="flush">
                <ListGroup.Item action href="/home" className="itemMenu" active={pathname.indexOf("/home") !== -1 || pathname === "/"} >
                    <FaHome /> Dashboard
                </ListGroup.Item>
            </ListGroup>
        )}
        </>
    );
    }
}

export default withRouter(SideV2);
